import { render } from "./FacilityInfoView.vue?vue&type=template&id=5ab6ce86"
import script from "./FacilityInfoView.vue?vue&type=script&lang=js"
export * from "./FacilityInfoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__